/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ opt: NonNullable<unknown> }} Style_Overrides_Manual_DescriptionInputs */

const fr_style_overrides_manual_description = /** @type {(inputs: Style_Overrides_Manual_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Passez l'option ${i?.opt} :`)
};

const en_style_overrides_manual_description = /** @type {(inputs: Style_Overrides_Manual_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Pass the ${i?.opt} option:`)
};

/**
* | output |
* | --- |
* | "Pass the {opt} option:" |
*
* @param {Style_Overrides_Manual_DescriptionInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const style_overrides_manual_description = /** @type {((inputs: Style_Overrides_Manual_DescriptionInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Style_Overrides_Manual_DescriptionInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_style_overrides_manual_description(inputs)
	return en_style_overrides_manual_description(inputs)
});